import FineUploaderTraditional from 'fine-uploader-wrappers'
import ServerProperties from '../../../config/server.js'
import moment from 'moment';

export default class FileUploader{
  Obj = null;
  constructor(UserReducer, AssetAlias, onsucces, onfailed, self,TrackingAlias='',is_tracking=false) {
      this.Obj = new FineUploaderTraditional({
        options: {
            // chunking: {
            //   enabled: true
            // },
            scaling: {
              sendOriginal: false,
              hideScaled: true,
              sizes: [
                {name: "small", maxSize: 500},
              ]
            },
            validation: {
              allowedExtensions: ['jpeg', 'jpg', 'png', 'gif'],
              sizeLimit: 15000000,  // bytes
            },
           request: {
              customHeaders : {
                "Authorization":"Bearer "+UserReducer.token,
              },
              params:{
                "AssetAlias":AssetAlias,
                "TakenTimeStamp": moment().unix(),
                "TrackingAlias":TrackingAlias,
                "is_tracking":is_tracking,
              },
              retry: {
                enableAuto: true
              },
              inputName:"Photo",
              paramsInBody:true,
              forceMultipart : true,
              endpoint: ServerProperties.ATM_CLOUD.API+"Asset/Photo/Upload/"
           },
           autoUpload : false,
           callbacks: {
              onAllComplete: function() { 
                onsucces(self) 
              },
              onError: function(id, name, errorReason, xhrOrXdr) {
                onfailed(errorReason)
              }
           }
        }
     })
   }
   SetAlias(param){
     this.Params = param
   }
}



// WEBPACK FOOTER //
// ./src/App/asset/photo/helper/request_props.js